import type { Company } from './models';

const istOffsetMs = 5.5 * 60 * 60 * 1000;

/** One calendar month after [now], at 23:59:59 IST. Mirrors [premiumPaidThroughOneMonthFromNow]. */
export function premiumPaidThroughOneMonthFromNow(now: Date = new Date()): Date {
  const ist = new Date(now.getTime() + istOffsetMs);
  const endWall = new Date(
    Date.UTC(
      ist.getUTCFullYear(),
      ist.getUTCMonth() + 1,
      ist.getUTCDate(),
      23,
      59,
      59,
    ),
  );
  return new Date(endWall.getTime() - istOffsetMs);
}

/** Mirrors `isPremiumAccessLapsed` in `lib/models/company_billing_plan.dart`. */
export function isPremiumAccessLapsed(company: {
  billingPlan?: string;
  premiumComplimentaryEndsAt?: Date;
  premiumSubscriptionPaidThrough?: Date;
  now?: Date;
}): boolean {
  const billingPlan = (company.billingPlan ?? 'premium').toLowerCase();
  if (billingPlan !== 'premium') return false;

  const now = company.now ?? new Date();
  const compEnd = company.premiumComplimentaryEndsAt;
  const paidThrough = company.premiumSubscriptionPaidThrough;

  // Missing dates are stamped to one month by ensureOwnedPremiumEndDates.
  // Until that write lands, do not treat the workspace as already expired.
  const legacyUnlimitedPremium = compEnd == null && paidThrough == null;
  if (legacyUnlimitedPremium) return false;

  const hasComplimentaryAccess =
    compEnd != null && now.getTime() <= compEnd.getTime();
  const hasPaidSubscriptionAccess =
    paidThrough != null && now.getTime() <= paidThrough.getTime();

  return !(hasComplimentaryAccess || hasPaidSubscriptionAccess);
}

export function companyWorkspaceIsOnHold(company: Company): boolean {
  return isPremiumAccessLapsed(company);
}
